import * as React from 'react';
import { useErrorLog } from '@core-front/error-provider';
const Heading = (props) => {
    const { element = 'h1', level, children, className, id, } = props;
    const { log } = useErrorLog();
    const isLevelValid = (l) => {
        if (!l) {
            return false;
        }
        if (l > 6 || l < 1) {
            log(`Level ${l} passed to Heading, which is incorrect. Rendering Heading with level 1 instead.`);
            return false;
        }
        return true;
    };
    const HeadingTag = isLevelValid(level) ? `h${level}` : element;
    const BEM = () => {
        const classArray = ['heading'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(HeadingTag, { className: BEM(), id: id }, children));
};
export { Heading as default, };
